const $ = require('jquery');

// import "slick-carousel";
import Swiper, {Lazy, Navigation, EffectFade, Thumbs, Autoplay} from 'swiper';

Swiper.use([Lazy, Navigation, EffectFade, Thumbs, Autoplay]);

document.querySelectorAll('.pf-wrapper').forEach(portfolio => {

    const slider = portfolio.querySelector('.pf-slider'),
          thumbs = portfolio.querySelector('.pf-thumb-slider');

    let mainSwiper = null,
        thumbSwiper = null;

    if (thumbs) {
        thumbSwiper = new Swiper(thumbs, {
            loop: true,
            spaceBetween: 0,
            slidesPerView: 5,
            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    slidesPerView: 7
                },
                1024: {
                    slidesPerView: 10
                },
                1200: {
                    slidesPerView: 15
                }
            }            
        });
    }

    mainSwiper = new Swiper(slider, {
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 3
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        effect: 'fade',
        speed: 800,
        fadeEffect: {
            crossFade: true
        },
        thumbs: thumbs ? {
            swiper: thumbSwiper,
            autoScrollOffset: 7
        } : false,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        }
    });

    
});



// document.querySelectorAll('.pf-slider').forEach(el => {
//     let swiper = new Swiper(el, {
//         preloadImages: false,
//         lazy: true
//     });
// })


/*$('.portfolio-full').each(function() {

    const $container = $(this),
          $portfolioSlider = $container.find('.portfolio-slider'),
          $thumbnailSlider = $container.find('.thumbnail-slider');

    $portfolioSlider.slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: true,
        fade: true,
        speed: 3000,
        asNavFor: $thumbnailSlider.length ? $thumbnailSlider : null,
        lazyLoad: 'ondemand',
        waitForAnimate: false,
        autoplay: true,
        autoplaySpeed: 2500,
        pauseOnFocus: false,
        pauseOnHover: false,
        prevArrow: `<button type="button" class="slick-prev">
            <svg viewBox="0 0 6.8982 13.229" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.76.142L.2872 6.6148 6.76 13.0876" fill="none" stroke="currentColor" stroke-width=".4011"/>
            </svg>
        </button>`,
        nextArrow: `<button type="button" class="slick-next">
            <svg viewBox="0 0 6.8982 13.229" xmlns="http://www.w3.org/2000/svg">
                <path d="M.14 13.088l6.4728-6.4728L.14.1424" fill="none" stroke="currentColor" stroke-width=".4011"/>
            </svg>
        </button>`
    });

    // $portfolioSlider.on('lazyLoaded', (e, slick, image, imageSource) => {
    //     image.parent().css('background-image', 'url("' + imageSource + '")');
    //     image.closest('.slick-slide').addClass('slide-loaded');
    //     image.remove();
    // });
    
    $thumbnailSlider.slick({
        slidesToShow: 15,
        slidesToScroll: 1,
        asNavFor: $portfolioSlider,
        lazyLoad: 'ondemand',
        centerMode: true,
        focusOnSelect: true,
        arrows: false,
        centerPadding: '0px',
        loop: false,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1700,
                settings: {
                    slidesToShow: 13
                }
            },
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 11
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 9
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 7
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 5
                }
            }
        ]
    });

});*/